import { render, staticRenderFns } from "./arrow-up-right-and-arrow-down-left-from-center.svg?vue&type=template&id=ace05034&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports